import { CalendarOptions } from '@fullcalendar/core';

export const DEFAULT_OPTIONS: CalendarOptions = {
	buttonIcons: {
		close: 'times',
		prev: 'chevron-left',
		next: 'chevron-right',
		prevYear: 'angle-double-left',
		nextYear: 'angle-double-right',
	},
	initialView: 'timeGridWeek',
	nowIndicator: true,
	themeSystem: 'bootstrap',
	selectable: false,
	selectMirror: false,
	editable: false,
	dayMaxEvents: true,
	eventMinHeight: 30,
	weekNumbers: true,
	navLinks: true,
	// slotDuration: '00:30:00',
	// slotMinTime: '07:00:00',
	// slotMaxTime: '22:30:00',
	dayMaxEventRows: 3, // not working with height auto
};
